import { render, staticRenderFns } from "./Builder.vue?vue&type=template&id=c766d4b0&scoped=true"
import script from "./Builder.vue?vue&type=script&lang=js"
export * from "./Builder.vue?vue&type=script&lang=js"
import style0 from "./Builder.vue?vue&type=style&index=0&id=c766d4b0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c766d4b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c766d4b0')) {
      api.createRecord('c766d4b0', component.options)
    } else {
      api.reload('c766d4b0', component.options)
    }
    module.hot.accept("./Builder.vue?vue&type=template&id=c766d4b0&scoped=true", function () {
      api.rerender('c766d4b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/reportbuilder/Builder.vue"
export default component.exports